export const generateQuestions = {
  id: 'f52e60e3-3a8d-42ca-9117-a4fa1081f61b',
  createdBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  createdDate: '2023-11-07T15:39:22.767Z',
  modifiedBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  modifiedDate: '2023-11-07T15:40:10.193Z',
  isDefault: false,
  isQueryable: false,
  status: 'draft',
  type: 'callableFeature',
  name: 'Generate potential questions',
  trigger: 'Feature Trigger',
  isDebugLoggingEnabled: false,
  workflow: {
    trigger: {
      type: 'callableFeature',
      name: 'Feature Trigger',
      triggerData: {
        payload: {
          name: 'Employee-Handbook.pdf',
          size: 58_980,
          assetId: '2ca186e2-b340-4d28-9ebb-6b728a8415ad',
          url: 'https://workgrid.com',
          text: '[Employee-Handbook.pdf](https://workgrid.com) (59 kB)'
        }
      }
    },
    steps: []
  }
}

export const openAndTest = {
  id: '1a688ee9-8af6-4d95-a643-f179cb9e6ae2',
  createdBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  createdDate: '2023-11-07T13:53:24.005Z',
  modifiedBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  modifiedDate: '2023-11-07T15:41:20.011Z',
  isDefault: false,
  isQueryable: false,
  status: 'draft',
  type: 'manual',
  audience: [],
  name: 'OPEN AND TEST - Prepare file',
  trigger: 'Manual',
  config: [
    {
      allowedValues: '',
      defaultValue: {},
      name: 'PDFDocument',
      formInputType: 'file-upload',
      description: 'Upload PDF document and make searchable',
      id: 'f72a4c34-3110-4000-b960-4586a838175f',
      type: 'object',
      isAppParameter: true,
      required: true
    }
  ],
  isDebugLoggingEnabled: false,
  workflow: {
    trigger: {
      type: 'manual',
      name: 'Manual'
    },
    steps: [
      {
        id: 'c31ea44c-eaf1-4fb5-af06-641615cfd4a0',
        name: 'Store user email',
        type: 'data-storage',
        stepData: {
          operation: 'modify',
          action: 'replace',
          objectName: 'userEmail',
          keyIdentifier: 'userEmail',
          data: '$.trigger.event.user.email ',
          expiresAfter: '7890000'
        },
        onSuccess: ['6db1999d-e1e9-41e5-acae-da2703f5caca'],
        retry: true,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'object',
          properties: {
            objectName: {
              type: 'string',
              example: 'userEmail'
            },
            keyIdentifier: {
              type: 'string',
              example: 'userEmail'
            },
            data: {
              type: 'string',
              format: 'email',
              example: 'user@workgrid.com'
            },
            expirationDate: {
              type: 'integer',
              example: 1_707_869_145
            }
          }
        }
      },
      {
        id: '6db1999d-e1e9-41e5-acae-da2703f5caca',
        name: 'Prep Event Data',
        type: 'script',
        stepData: {
          parameters: [
            {
              id: '368cda34-2a7b-4370-b420-649bd6bcbe62',
              key: 'pdf',
              value: '$.config.PDFDocument'
            },
            {
              id: '267d5977-b196-4693-9c3f-9fc9d775b116',
              key: 'user',
              value: '$.trigger.event.user'
            }
          ],
          body: "const lodash = require('lodash')\nlet output = input.pdf\nlodash.set(output, 'user', input.user)\n//data to be returned from the script step\ndone(output)"
        },
        onSuccess: ['93abb782-47e5-4fc0-aaf9-d20cbafbbcc5'],
        retry: false,
        timeout: 100,
        continueOnError: false
      },
      {
        id: '93abb782-47e5-4fc0-aaf9-d20cbafbbcc5',
        name: 'Run Process File Feature',
        type: 'callable-feature',
        stepData: {
          isAsync: true,
          featureId: '$.feature.4c42aaae-e321-4732-b4e0-63b8ab176324',
          payloadVariable: '$.6db1999d-e1e9-41e5-acae-da2703f5caca.output'
        },
        retry: false,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'object',
          properties: {
            response: {
              type: 'string',
              example: 'Async feature executed'
            }
          }
        },
        onSuccess: ['665eb8e1-e20d-43e6-b1a4-96f1f040824d']
      },
      {
        id: '665eb8e1-e20d-43e6-b1a4-96f1f040824d',
        name: 'Run Generate Questions Feature',
        type: 'callable-feature',
        stepData: {
          isAsync: true,
          featureId: '$.feature.f52e60e3-3a8d-42ca-9117-a4fa1081f61b',
          payloadVariable: '$.config.PDFDocument'
        },
        retry: false,
        timeout: 100,
        continueOnError: false
      }
    ]
  }
}

export const processFile = {
  id: '4c42aaae-e321-4732-b4e0-63b8ab176324',
  createdBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  createdDate: '2023-11-07T13:53:23.167Z',
  modifiedBy: '46abb368-9a95-425c-bf7f-9386c2f2e4f8',
  modifiedDate: '2024-02-07T15:43:21.436Z',
  isDefault: false,
  isQueryable: false,
  status: 'draft',
  type: 'callableFeature',
  audience: [],
  name: 'Process File',
  trigger: 'Feature Trigger',
  config: [
    {
      allowedValues: '',
      defaultValue: '[]',
      name: 'structuredChunkRecords',
      description: '',
      id: '23dee836-867f-4690-a3c6-86cb555c6a1c',
      type: 'array',
      required: false
    },
    {
      allowedValues: '',
      defaultValue: '',
      displayName: 'Document Id',
      name: 'document_id',
      formInputType: 'text',
      description: '',
      id: '52399ed3-39dd-4d11-824d-88c629521cf9',
      type: 'string',
      required: false
    }
  ],
  isDebugLoggingEnabled: false,
  workflow: {
    trigger: {
      type: 'callableFeature',
      name: 'Feature Trigger',
      triggerData: {
        payload: {
          name: 'Employee-Handbook.pdf',
          size: 58_980,
          assetId: '2ca186e2-b340-4d28-9ebb-6b728a8415ad',
          url: 'https://workgrid.com',
          text: '[Employee-Handbook.pdf](https://workgrid.com) (59 kB)'
        }
      }
    },
    steps: [
      {
        id: '7a3d0d05-d18a-44ed-947b-37c6224b277b',
        name: 'Read Document ID',
        type: 'data-storage',
        stepData: {
          operation: 'read',
          action: 'get-record-by-key',
          objectName: 'document_id',
          keyIdentifier: 'document_id',
          data: '',
          expiresAfter: '7890000'
        },
        onSuccess: ['397ffda1-f379-4d55-b0e4-de3dfb4dfc85'],
        retry: true,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'object',
          properties: {
            objectName: {
              type: 'string',
              example: 'document_id'
            },
            keyIdentifier: {
              type: 'string',
              example: 'document_id'
            },
            data: {
              type: 'string',
              example: 'c8167f2e-a59a-48f4-ac88-a...'
            }
          }
        }
      },
      {
        id: '397ffda1-f379-4d55-b0e4-de3dfb4dfc85',
        name: 'If Document ID Found',
        type: 'boolean',
        stepData: {
          conditions: [
            {
              filters: [
                {
                  leftComparator: '$.7a3d0d05-d18a-44ed-947b-37c6224b277b.output.data',
                  operator: 'pr',
                  rightComparator: ''
                }
              ],
              expression: '$.7a3d0d05-d18a-44ed-947b-37c6224b277b.output.data pr'
            }
          ],
          onTrue: [
            {
              id: '17ac80dc-7c27-406b-b345-cb36eb4e2d03',
              name: 'Set Document ID',
              type: 'set-config-variable',
              stepData: {
                configVariable: 'document_id',
                configValue: '$.7a3d0d05-d18a-44ed-947b-37c6224b277b.output.data ',
                shouldAppend: false
              },
              retry: true,
              timeout: 100,
              continueOnError: false
            }
          ],
          onFalse: [
            {
              id: '243de83b-ab79-43a0-99e8-a8d3383628b2',
              name: 'Generate Document ID',
              type: 'script',
              stepData: {
                body: "const crypto = require('crypto')\n\nconst documentId = crypto.randomUUID()\n\ndone(documentId)"
              },
              onSuccess: ['af4a7aef-9e89-4bf1-992a-6783a569abdd'],
              retry: true,
              timeout: 100,
              continueOnError: false,
              output: {
                type: 'string',
                example: 'c8167f2e-a59a-48f4-ac88-a...'
              }
            },
            {
              id: 'af4a7aef-9e89-4bf1-992a-6783a569abdd',
              name: 'Store Document ID',
              type: 'data-storage',
              stepData: {
                operation: 'modify',
                action: 'replace',
                objectName: 'document_id',
                keyIdentifier: 'document_id',
                data: '$.243de83b-ab79-43a0-99e8-a8d3383628b2.output ',
                expiresAfter: ''
              },
              onSuccess: ['d1ac608a-98a8-4a90-a6e9-c8c39f17440c'],
              retry: true,
              timeout: 100,
              continueOnError: false,
              output: {
                type: 'object',
                properties: {
                  objectName: {
                    type: 'string',
                    example: 'document_id'
                  },
                  keyIdentifier: {
                    type: 'string',
                    example: 'document_id'
                  },
                  data: {
                    type: 'string',
                    example: 'c8167f2e-a59a-48f4-ac88-a...'
                  }
                }
              }
            },
            {
              id: 'd1ac608a-98a8-4a90-a6e9-c8c39f17440c',
              name: 'Set Document ID',
              type: 'set-config-variable',
              stepData: {
                configVariable: 'document_id',
                configValue: '$.243de83b-ab79-43a0-99e8-a8d3383628b2.output ',
                shouldAppend: false
              },
              retry: true,
              timeout: 100,
              continueOnError: false
            }
          ]
        },
        onSuccess: ['a65c2508-feb9-49bb-b7bc-742d6cbb4b63'],
        retry: true,
        timeout: 100,
        continueOnError: false
      },
      {
        id: 'a65c2508-feb9-49bb-b7bc-742d6cbb4b63',
        name: 'Store document metadata in Data Storage',
        type: 'data-storage',
        stepData: {
          operation: 'modify',
          action: 'replace',
          objectName: 'documentMetadata',
          keyIdentifier: 'documentMetadata',
          data: '$.trigger.event',
          expiresAfter: ''
        },
        onSuccess: ['ca52ae75-b169-430a-9c7c-f04b7e7ceeac'],
        retry: true,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'object',
          properties: {
            objectName: {
              type: 'string',
              example: 'documentMetadata'
            },
            keyIdentifier: {
              type: 'string',
              example: 'documentMetadata'
            },
            data: {
              type: 'object',
              properties: {
                name: {
                  type: 'string',
                  example: 'Employee-Handbook.pdf'
                },
                size: {
                  type: 'integer',
                  example: 58_980
                },
                assetId: {
                  type: 'string',
                  example: '2ca186e2-b340-4d28-9ebb-6...'
                },
                url: {
                  type: 'string',
                  format: 'uri',
                  example: 'https://workgrid.com'
                },
                text: {
                  type: 'string',
                  format: 'style',
                  example: '[Employee-Handbook.pdf](h...'
                },
                sendToDryRunUser: {
                  type: 'boolean',
                  example: true
                },
                sendToWorkshopDeveloper: {
                  type: 'boolean'
                },
                user: {
                  type: 'object',
                  properties: {
                    id: {
                      type: 'string',
                      example: '46abb368-9a95-425c-bf7f-9...'
                    },
                    employeeNumber: {
                      type: 'string',
                      format: 'date-time',
                      example: '123456'
                    },
                    News: {
                      type: 'string',
                      example: 'false'
                    },
                    customBooleanTargetTest: {
                      type: 'string',
                      example: 'false'
                    },
                    testVal: {
                      type: 'string',
                      example: 'false'
                    },
                    ukgReadyUserId: {
                      type: 'string',
                      format: 'utc-millisec',
                      example: '3190159'
                    }
                  }
                },
                workshopDeveloper: {
                  type: 'string',
                  format: 'email',
                  example: 'test.user@workgrid.co...'
                }
              }
            }
          }
        }
      },
      {
        id: 'ca52ae75-b169-430a-9c7c-f04b7e7ceeac',
        name: 'Document Search Storage',
        type: 'document-search-storage',
        stepData: {
          mode: 'insert',
          document: '$.trigger.event ',
          queryableFeatureId: '$.feature.8421da73-13b6-4546-ae4d-0c45a12830ac',
          insertDocumentId: '$.config.document_id ',
          deleteDocumentId: ''
        },
        onSuccess: ['de581945-754f-42b7-9123-e2dcde0ef0eb'],
        retry: false,
        timeout: 900,
        continueOnError: false
      },
      {
        id: 'de581945-754f-42b7-9123-e2dcde0ef0eb',
        name: 'Deploy App',
        type: 'deploy-feature',
        stepData: { mode: 'deployApp' },
        onSuccess: ['151e4bfc-ae5e-4bed-b913-111a3206a213'],
        retry: true,
        timeout: 100,
        continueOnError: false
      },
      {
        id: '151e4bfc-ae5e-4bed-b913-111a3206a213',
        name: 'Get User Email',
        type: 'data-storage',
        stepData: {
          operation: 'read',
          action: 'get-all-object-records',
          objectName: 'userEmail',
          keyIdentifier: 'email',
          data: '',
          expiresAfter: '7890000'
        },
        onSuccess: ['9e6108b0-cfa9-49cb-b60d-374f0e0d790b'],
        retry: true,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'array',
          properties: {
            objectName: {
              type: 'string',
              example: 'userEmail'
            },
            keyIdentifier: {
              type: 'string',
              example: 'userEmail'
            },
            expirationDate: {
              type: 'integer',
              example: 1_707_868_967
            },
            data: {
              type: 'string',
              format: 'email',
              example: 'user@workgrid.co...'
            }
          }
        }
      },
      {
        id: '9e6108b0-cfa9-49cb-b60d-374f0e0d790b',
        name: 'Send Documented Processed Notification',
        type: 'send-smart-notification',
        stepData: {
          notifications: [
            {
              summary: {
                title: 'Your document is ready',
                body: 'The following document has been processed: $.app.name, ($.trigger.event.name) \n \nYou can now begin querying your document.'
              },
              detail: [],
              category: 'Chat to Document',
              from: {
                name: 'Chat to Document',
                iconUrl: 'https://cdn.dev.workgrid.com/templates/d699326b-b73b-4cc8-83d6-6de4efbe74d8/icon.png'
              },
              location: 'toknow',
              audience: [
                {
                  id: '28bec3b0-6882-4a5f-b744-cc9073fc1f2a',
                  filters: [
                    {
                      attribute: {
                        id: 'individual',
                        displayName: 'Individual',
                        type: 'string',
                        urn: 'userName',
                        scimAttributeName: 'individual'
                      },
                      displayValue: '$.151e4bfc-ae5e-4bed-b913-111a3206a213.output[0].data',
                      id: '1cebe783-9a05-47aa-adf9-ddab055e9d0c',
                      operator: 'eq',
                      value: '$.151e4bfc-ae5e-4bed-b913-111a3206a213.output[0].data',
                      scimExpression: {
                        type: 'filter',
                        value: 'userName eq "$.151e4bfc-ae5e-4bed-b913-111a3206a213.output[0].data"'
                      }
                    }
                  ],
                  scimExpression: {
                    type: 'filter',
                    value: 'userName eq "$.151e4bfc-ae5e-4bed-b913-111a3206a213.output[0].data"'
                  }
                }
              ],
              notificationSource: 'd699326b-b73b-4cc8-83d6-6de4efbe74d8',
              priority: 'informational',
              hiddenAfter: 21,
              isHiddenBeforeRelativeToUserTimezone: false,
              correlationId: '',
              actions: []
            }
          ],
          type: 'notification.create'
        },
        retry: true,
        timeout: 100,
        continueOnError: false
      }
    ]
  }
}

export const searchAndSummarize = {
  id: '8421da73-13b6-4546-ae4d-0c45a12830ac',
  createdBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  createdDate: '2023-11-07T13:53:22.340Z',
  modifiedBy: '5c1e8559-6586-487b-b60d-c680dcab9bcf',
  modifiedDate: '2023-11-07T15:43:21.337Z',
  isDefault: true,
  isQueryable: false,
  responseType: 'rag',
  status: 'draft',
  type: 'microappView',
  name: 'Document search and summarize',
  audience: [],
  trigger: 'App UI',
  isDebugLoggingEnabled: false,
  workflow: {
    trigger: {
      type: 'microappView',
      name: 'App UI',
      triggerData: {
        payload: '{}',
        hasChatDiscoverability: false,
        responseType: 'rag'
      }
    },
    steps: [
      {
        id: '97783ef6-a0dd-46a8-a81e-7e7b85a71029',
        name: 'Get document metadata from Data Storage',
        type: 'data-storage',
        stepData: {
          operation: 'read',
          action: 'get-all-object-records',
          objectName: 'documentMetadata',
          keyIdentifier: '',
          data: ''
        },
        onSuccess: ['ab8140a1-0c1d-436e-acfd-77370f28994b'],
        retry: true,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'array',
          properties: {
            objectName: {
              type: 'string',
              example: 'documentMetadata'
            },
            keyIdentifier: {
              type: 'string',
              example: 'documentMetadata'
            },
            data: {
              type: 'object',
              properties: {
                name: {
                  type: 'string',
                  example: 'Employee-Handbook.pdf'
                },
                size: {
                  type: 'integer',
                  example: 58_980
                },
                assetId: {
                  type: 'string',
                  example: '71a79ef6-368e-447f-84db-0...'
                },
                url: {
                  type: 'string',
                  format: 'uri',
                  example: 'https://workgridsoftware....'
                },
                text: {
                  type: 'string',
                  format: 'style',
                  example: '[Eye Care Policy ...'
                }
              }
            }
          }
        }
      },
      {
        id: 'ab8140a1-0c1d-436e-acfd-77370f28994b',
        name: 'Get document chunk questions',
        type: 'data-storage',
        stepData: {
          operation: 'read',
          action: 'get-all-object-records',
          keyIdentifier: '',
          objectName: 'chunkQuestions',
          data: ''
        },
        onSuccess: ['57e3cefa-3c0b-46af-9736-011c4f94c0d8'],
        retry: false,
        timeout: 100,
        continueOnError: true,
        output: {
          type: 'array',
          properties: {
            objectName: {
              type: 'string',
              example: 'chunkQuestions'
            },
            keyIdentifier: {
              type: 'string',
              example: 'Dummy Eye Care Policy.pdf...'
            },
            expirationDate: {
              type: 'integer',
              example: 1_707_939_570
            },
            data: {
              type: 'array',
              items: {
                type: 'array',
                items: {
                  type: 'string',
                  example: 'What is the purpose of th...'
                }
              }
            }
          }
        }
      },
      {
        id: '57e3cefa-3c0b-46af-9736-011c4f94c0d8',
        name: 'Pick random example questions',
        type: 'script',
        stepData: {
          parameters: [
            {
              id: 'f250887f-8d39-4c5a-93fd-0a5584cc17b0',
              key: 'questionArrays',
              value: '$.ab8140a1-0c1d-436e-acfd-77370f28994b.output[0].data'
            }
          ],
          body: "const _ = require('lodash')\nlet randomQuestions = []\nif (input.questionArrays && input.questionArrays.length > 0) {\n    const flattenedList = input.questionArrays.flat(1)\n    randomQuestions = _.sampleSize(flattenedList, 3)\n}\n\ndone({ randomQuestions })"
        },
        onSuccess: ['39a2a40b-ffad-4818-b9b6-11377842c424'],
        retry: true,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'object',
          properties: {
            randomQuestions: {
              type: 'array',
              items: {
                type: 'string',
                example: "Who is considered a 'user..."
              }
            }
          }
        }
      },
      {
        id: '39a2a40b-ffad-4818-b9b6-11377842c424',
        name: 'Generate Document Summary',
        type: 'script',
        stepData: {
          parameters: [
            {
              id: '2cfb8763-8988-4c4b-a760-d8a67b7863c6',
              key: 'documentName',
              value: '$.97783ef6-a0dd-46a8-a81e-7e7b85a71029.output[0].data.name'
            },
            {
              id: 'dd06b8fc-9231-4769-8bc4-5f1f5111f854',
              key: 'documentUrl',
              value: '$.97783ef6-a0dd-46a8-a81e-7e7b85a71029.output[0].data.url'
            },
            {
              id: '4fdcc038-3ac2-4a8f-957f-e39bf2578875',
              key: 'sampleQuestions',
              value: '$.57e3cefa-3c0b-46af-9736-011c4f94c0d8.output.randomQuestions'
            }
          ],
          body: "const header = `This is the \"Chat to Document\" app for document: [${input.documentName}](${input.documentUrl})`\nlet summary = ''\nif (input.sampleQuestions && input.sampleQuestions.length > 0) {\n    summary = `\\n\n_Below are a few example questions that you can ask about this document:_\n- ${input.sampleQuestions.join('\\r- ')}\n`\n}\n\n//data to be returned from the script step\ndone({ header, summary })"
        },
        onSuccess: ['4bbd16c6-2648-4308-87e7-d9de13e18e7a'],
        retry: true,
        timeout: 100,
        continueOnError: false,
        output: {
          type: 'object',
          properties: {
            header: {
              type: 'string',
              format: 'style',
              example: 'This is the "Chat to Docu...'
            },
            summary: {
              type: 'string',
              example: '\n\n_Below are a few exampl...'
            }
          }
        }
      },
      {
        id: '4bbd16c6-2648-4308-87e7-d9de13e18e7a',
        name: 'Response',
        type: 'response',
        stepData: {
          parameters: [
            {
              id: '57916ddd-c406-4403-886a-5d96e4ad4be1',
              value:
                '$.39a2a40b-ffad-4818-b9b6-11377842c424.output.header $.39a2a40b-ffad-4818-b9b6-11377842c424.output.summary '
            }
          ]
        },
        retry: true,
        timeout: 100,
        continueOnError: false
      }
    ]
  }
}
